/**
 * Formats optimized speeds from numeric values to string representation with proper decimal formatting.
 *
 * @param optimizedSpeeds - Object containing optimized speed values as numbers corresponding to different ratings.
 *
 * @returns A formatted object with optimized speed values as strings or `undefined` if the input is not provided.
 */
export const isValidNumber = (str?: string) => {
  return str ? !isNaN(Number(str)) && !isNaN(parseFloat(str)) : false;
};
